<div
	(click)="!utilService.isNullOrUndefined(dot) ? animate() : ''; $event.stopPropagation()"
	*ngIf="!utilService.isNullOrUndefined(mc) && !isMCFlipped"
	[ngStyle]="{
		cursor: !utilService.isNullOrUndefined(dot) && dot.length > 0 ? 'pointer' : 'normal'
	}"
	fxFlex
	fxLayoutAlign="{{ layout }}"
>
	<span>
		MC/MX: {{ mc }}
		<mat-icon
			(click)="$event.stopPropagation(); utilService.copyToClipboard(mc, COPY_TO_CLIPBOARD_MSGS.MC)"
			[inline]="true"
			class="copy-icon"
		>
			file_copy
		</mat-icon>
	</span>
</div>

<div
	(click)="!utilService.isNullOrUndefined(mc) ? animate() : ''; $event.stopPropagation()"
	*ngIf="!utilService.isNullOrUndefined(dot) && isMCFlipped"
	[ngStyle]="{ cursor: !utilService.isNullOrUndefined(mc) && mc.length > 0 ? 'pointer' : 'normal' }"
	fxFlex
	fxLayoutAlign="{{ layout }}"
>
	<span>
		DOT: {{ dot }}
		<mat-icon
			(click)="
				$event.stopPropagation(); utilService.copyToClipboard(dot, COPY_TO_CLIPBOARD_MSGS.DOT)
			"
			[inline]="true"
			class="copy-icon"
		>
			file_copy
		</mat-icon>
	</span>
</div>
